import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Collapse, Card, Button } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import "../styles/AcotAcreditedColleges.css";
import { useNavigate } from "react-router-dom";

const OccupationalTherapyPrograms = () => {
  const [searchValue, setSearchValue] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState("10");
  const [colleges, setColleges] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));
  const [showContent, setShowContent] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [pageLoading, setPageLoading] = useState(false);
  const programBoxRef = useRef(null);
  const paginationClicked = useRef(false);

  const navigate = useNavigate();

  const ELIGIBILITY_CRITERIA_PDF = `${process.env.PUBLIC_URL}/documents/acas-eligibility-criteria.pdf`;
  const APPLICATION_FORM_PDF = `${process.env.PUBLIC_URL}/documents/acas-application-form.pdf`;

  const openPdf = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleMemberLogin = () => {
    navigate("/member-login");
  };

  const handleEdcclogin = () => {
    navigate("/edcc-login");
  };

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value); // Update input field immediately
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchValue);
      setCurrentPage(1); // Reset to page 1 on search
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  useEffect(() => {
    if (paginationClicked.current && !pageLoading && programBoxRef.current) {
      const headerOffset = 120;
      const elementPosition =
        programBoxRef.current.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
      paginationClicked.current = false; // Reset after scroll
    }
  }, [pageLoading]);

  const handleEntriesChange = (e) => {
    setEntriesPerPage(e.target.value);
    setCurrentPage(1);
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      paginationClicked.current = true;
      setPageLoading(true);
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    const totalPages = Math.ceil(totalItems / parseInt(entriesPerPage));
    if (currentPage < totalPages) {
      paginationClicked.current = true;
      setPageLoading(true);
      setCurrentPage(currentPage + 1);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState) {
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  useEffect(() => {
    const fetchColleges = async () => {
      try {
        setLoading(true);

        const params = new URLSearchParams({
          page: currentPage.toString(),
          limit: entriesPerPage,
          ...(searchValue && { search: searchValue }),
        });

        const response = await fetch(
          `${process.env.REACT_APP_BASEURL}/getAllColleges?${params.toString()}`
        );

        if (!response.ok) {
          throw new Error("Failed to fetch colleges");
        }

        const responseData = await response.json();
        const data = responseData.data || [];

        // Filter only by status (backend handles isDeleted)
        const activeColleges = data.filter((college) => college.status === 1);

        setColleges(activeColleges);
        setTotalItems(responseData.pagination?.totalItems || 0); // Use backend total
        setError(null);
      } catch (err) {
        console.error("Error fetching colleges:", err);
        setError(err.message);
        setColleges([]);
        setTotalItems(0);
      } finally {
        setLoading(false);
        setPageLoading(false);
      }
    };

    fetchColleges();
  }, [currentPage, entriesPerPage, debouncedSearch]); // Depend on these to refetch

  // filter based on search
  const filteredColleges = colleges;

const highlightText = (text, searchValue) => {
  if (!searchValue || !text) return text;

  const regex = new RegExp(`(${searchValue})`, "gi");
  const parts = text.split(regex);

  return parts.map((part, index) =>
    part.toLowerCase() === searchValue.toLowerCase() ? (
      <span
        key={index}
        style={{
          background: "#f0ee6c",   // yellow
          color: "#000",
          padding: "2px 0px",
          borderRadius: "4px",
          fontWeight: 600
        }}
      >
        {part}
      </span>
    ) : (
      part
    )
  );
};

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">
              All India Occupational Therapists' Association
            </h1>
            {!tokenState && (
              <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <section className="program-section">
            <Container>
              <h2>Occupational Therapy Education Programs in India</h2>
              <Row>
                <Col md={12}>
                  <div className="button-container">
                    <a
                      href="#accreditation-documents"
                      className="learn-more-btn"
                      onClick={(e) => e.preventDefault()}
                    >
                      <span className="material-symbols-outlined d-none d-lg-flex">
                        school
                      </span>
                     Click the "Click Here" button to view the eligibility criteria for AIOTA Certificate of Academic Standards(ACAS) & AIOTA Membership, and download the application form.
                    </a>
                    <button
                      type="button"
                      className="click-here-btn w-auto"
                      onClick={() => setShowContent(!showContent)}
                      aria-expanded={showContent}
                      aria-controls="accreditation-documents"
                    >
                      Click Here
                    </button>
                  </div>
                  <Collapse in={showContent}>
                    <div id="accreditation-documents">
                      <Card className="border-1 shadow-sm mb-3">
                        <Card.Body className="accreditation-documents-body">
                          <div className="accreditation-documents-actions">
                            <Button
                              type="button"
                              variant="primary"
                              className="accreditation-doc-btn"
                              onClick={() => openPdf(ELIGIBILITY_CRITERIA_PDF)}
                            >
                              Eligibility Criteria
                            </Button>
                            <Button
                              type="button"
                              variant="primary"
                              className="accreditation-doc-btn"
                              onClick={() => openPdf(APPLICATION_FORM_PDF)}
                            >
                              Application Form
                            </Button>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                  </Collapse>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                {pageLoading && (
                  <div className="table-overlay">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                )}
                  <div className="program-box" ref={programBoxRef}>
                    <div className="table-controls">
                      <div className="entries-control">
                        <label>Show</label>
                        <select
                          value={entriesPerPage}
                          onChange={handleEntriesChange}
                        >
                          <option>10</option>
                          <option>25</option>
                          <option>50</option>
                          <option>100</option>
                        </select>
                        <label>entries</label>
                      </div>
                      <div className="search-control">
                        <div className="search-container">
                          <input
                            type="text"
                            value={searchValue}
                            onChange={handleSearchChange}
                            className="search-input"
                            placeholder="Search..."
                          />
                        </div>
                      </div>
                    </div>

                    {loading ? (
                      <p>Loading colleges...</p>
                    ) : error ? (
                      <p style={{ color: "red" }}>{error}</p>
                    ) : (
                      <table className="program-table">
                        <thead>
                          <tr>
                            <th>COLLEGE</th>
                            <th>ACCREDITATION STATUS</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredColleges.length > 0 ? (
                            filteredColleges.map((college) => (
                              <tr key={college._id}>
                                <td>
                                  <p>
                                    <strong>
                                      {highlightText(college.college_name, searchValue)} (
                                      {college.accredition_status}{" "}
                                      {college.accreditation_date
                                        ? new Date(
                                            college.accreditation_date
                                          ).getFullYear()
                                        : ""}
                                      -
                                      {college.valid_until
                                        ? new Date(
                                            college.valid_until
                                          ).getFullYear()
                                        : ""}
                                      )
                                    </strong>
                                  </p>
                                  <p>University: {highlightText(college.university_name, searchValue)}</p>
                                  <p>
                                    Principal: {highlightText(college.principal_name, searchValue)}{" "}
                                    {college.phone} / {college.landline}{" "}
                                    {college.email}
                                  </p>
                                  <p>{college.address}</p>
                                  <p>
                                    <span className="course-tag">
                                      Course: {college.course}
                                    </span>
                                    <span className="seats-tag">
                                      Seats: {college.seats}
                                    </span>
                                  </p>
                                </td>
                                <td>
                                  <button
                                    className={
                                      college.accredition_status
                                        ? "accreditation-btn"
                                        : "accreditation-btn-not-available"
                                    }
                                    style={{
                                      cursor: "default",
                                    }}
                                  >
                                    {college.accredition_status ||
                                      "Data not available"}
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={2}>No colleges found</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}

                    <div className="pagination-controls">
                      <p style={{ margin: 0 }}>
                        {colleges.length > 0
                          ? `Showing ${
                              (currentPage - 1) * parseInt(entriesPerPage) + 1
                            } to ${
                              (currentPage - 1) * parseInt(entriesPerPage) +
                              colleges.length
                            } of ${totalItems}`
                          : `0 of ${totalItems}`}{" "}
                        entries
                      </p>
                      <div className="pagination">
                        <button
                          onClick={handlePrevious}
                          disabled={currentPage === 1 || loading}
                        >
                          Previous
                        </button>
                        <button className="active">{currentPage}</button>
                        <button
                          onClick={handleNext}
                          disabled={
                            currentPage >=
                              Math.ceil(
                                totalItems / parseInt(entriesPerPage)
                              ) || loading
                          }
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default OccupationalTherapyPrograms;
